import IconClose from '@apollo/icons/default/IconClose.svg';
import IconSearch from '@apollo/icons/default/IconSearch.svg';
import { IconButton, Input } from '@apollo/orbit';
import React from 'react';

type SearchProps = {
  placeholderText: string;
  inputValue: string;
  setInputValue: (arg: string) => void;
  onClear?: () => void;
};

export const DEFAULT_SEARCH_VALUE = '';

export const SearchFilter = React.forwardRef<HTMLInputElement, SearchProps>(
  (
    { placeholderText, inputValue, setInputValue, onClear },
    initialFocusRef,
  ) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    const onInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
    };

    return (
      <Input
        ref={initialFocusRef ?? inputRef}
        className="my-[6px]"
        placeholder={placeholderText}
        value={inputValue}
        onInput={onInput}
        leftElement={<IconSearch className="pointer-events-none size-4" />}
        rightElement={
          inputValue ? (
            <IconButton
              aria-label="Clear search"
              data-testid="clear-search"
              size="sm"
              variant="hidden"
              onClick={() => {
                setInputValue(DEFAULT_SEARCH_VALUE);
                inputRef.current?.focus();
                onClear?.();
              }}
            >
              <IconClose />
            </IconButton>
          ) : null
        }
      />
    );
  },
);
